import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import * as moment from 'moment-jalaali';
import { CookieService } from 'ngx-cookie-service';
import { BaseService } from '../../../providers/base.service';
import { BaseComponent } from '../base/base.component';

@Component({
  template: ''
}) export abstract class BaseFormComponent extends BaseComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseService,
  ) {
    super(service, translator, cookieService, titleService);
    // this.api = `api/${this.entity}/create`;
  }
  public get id(): any {
    return this._id;
  }
  public set id(v: any) {
    this._id = v;
    this.body[this.pkey] = v;
  }
  public validateLog: any[] = [];
  @Input() hiddenApply = true;
  @Input() hiddenCancel = false;
  @Input() hiddenReset = false;
  @Input() hiddenClose = false;
  @Input() title: string;
  @Output() done: EventEmitter<object> = new EventEmitter<object>();
  @ViewChild('formVar') form: DxFormComponent;

  public get invalid(): boolean {
    return false;
    // if (this.form && this.form.instance) {
    //   return !this.form.instance.validate().isValid;
    // } else {
    //   return false;
    // }
  }
  meta: any;
  fields: any = [];
  lists: any = [];
  readonly = false;
  uploadingList = [];
  uploadPath;
  formData: any = [];
  public loading = false;
  body: any = {};
  forceUpdate = false;
  isEdit: boolean = false;
  params: any = {};
  info: string;
  private _id: any;

  public colCount: number = 2;
  public entityName = '';
  public pkey = 'id';
  public subentityName = '';
  public supressSave = false;

  // checkFieldAccess(item) {
  //   return new Promise((resolve, reject) => {
  //     item.checked = true;
  //     if (!item.secure) {
  //       resolve(true);
  //     } else if (this.token) {
  //       this.service.checkAccess(this.title.includes('CREATE') ? 'CREATE' : 'UPDATE',
  //         this.entityName, '*', item.secureKey || item.name).subscribe((result: any) => {
  //           if (result.ok) {
  //             item.secure = !result.json().granted;
  //           }
  //           resolve(true);
  //         }, error => {
  //           reject(error);
  //         });
  //     } else {
  //       item.secure = true;
  //       resolve(false);
  //     }
  //   });
  // }

  getMeta(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.entityName) {
        // tslint:disable-next-line:max-line-length
        const key = `form_${this.entityName.toLowerCase()}_${(this.subentityName || '').toLowerCase()}_${this.isEdit ? 'UPDATE' : 'CREATE'}`;
        const cached = sessionStorage.getItem(key);
        if (cached) {
          resolve(JSON.parse(cached));
        } else {
          this.service.form(
            this.entityName.toLowerCase(),
            (this.subentityName || '').toLowerCase(),
            this.isEdit ? 'UPDATE' : 'CREATE'
          ).subscribe((result: any) => {
            const js = result;
            sessionStorage.setItem(key, JSON.stringify(js));
            resolve(js);
          }, error => {
            console.error(error);
            reject(error);
          });
        }
      } else if (!this.fields || !this.fields.length) {
        reject('Entity is not specified.');
      } else {
        resolve({ fields: this.fields });
      }
    });
  }

  async ngOnInit() {
    try {
      await super.ngOnInit();
      this.hiddenCancel = this.hiddenCancel ||
        this.activeModal.close.toString().includes('{}');
      this.meta = await this.getMeta();
      if (this.meta.fields) {
        this.info = this.meta.info;
        this.pkey = this.meta.pkey || this.pkey;
        this.colCount = this.meta.colCount || this.colCount;
        this.title = this.meta.title || this.title;
        if (this.meta.hiddenReset) {
          this.hiddenReset = this.meta.hiddenReset;
        }
        this.fields = this.meta.fields;
        for (const field of this.fields) {
          this.initField(field);
        }
        if (this.isEdit) {
          const body = {};
          body[this.pkey] = this.id;
          body['fields'] = this.fields.map(f => f.name);
          const result = (await this.service.apiCall(`api/${this.entityName.toLowerCase()}/read`, body).toPromise())[0];
          await this.manipulate(result);
          this.formData = result;
        }

        for (const field of this.fields) {
          await this.customize(field);
        }
      }
    } catch (error) {
      this.handleError(error);
    }
  }

  initField(field: any) {
    if (field.type && field.type.name) {
      switch (field.type.name.toLowerCase()) {
        case 'text':
        case 'tel':
        case 'mobile':
          field.editorType = 'dxTextBox';
          break;
        case 'number':
          field.editorType = 'dxNumberBox';
          break;
        case 'money':
          field.editorType = 'dxNumberBox';
          break;
        case 'autocomplete':
          field.editorType = 'dxAutocomplete';
          break;
        case 'select':
        case 'select-simple':
          field.editorType = 'dxSelectBox';
          break;
        case 'tagbox':
        case 'tagbox-simple':
          field.editorType = 'dxTagBox';
          break;
        case 'switch':
          field.editorType = 'dxSwitch';
          break;
        case 'checkbox':
          field.editorType = 'dxCheckBox';
          break;
        case 'radio':
          field.editorType = 'dxRadioGroup';
          break;
        case 'textarea':
          field.editorType = 'dxTextArea';
          break;
        case 'uploader':
          field.editorType = 'dxFileUploader';
          break;
        case 'list':
          if (!this.formData[field.name]) {
            this.formData[field.name] = field.value;
          }
          break;
        default:
          break;
      }

    }
  }

  async customize(field) {
    return new Promise(async (resolve, reject) => {
      try {
        field = await this.custom(field);
        if (field.type && field.type.name) {
          if (field.type.option && field.type.option.api) {
            await this.loadFieldOptions(field);
            // if (field.type.name.toLowerCase() === 'autocomplete') {
            //   this.loadFieldOptions(field);
            // } else {
            //   await this.loadFieldOptions(field);
            // }
          }

          if (field.type.name === 'list') {
            for (const col of field.type.columns) {
              if (col.type.option && col.type.option.api) {
                await this.loadFieldOptions(col);
              }
            }
          }

          if (!this.isEdit
            && field.type.options
            && field.type.options.length === 1 && field.rules
            && field.rules.length
            && field.rules.find(r => r.type === 'required')) {
            if (field.type.options.name) {
              field.value = field.type.options[0].value;
            } else {
              field.value = field.type.options[0];
            }
            if (!this.formData[field.name]) {
              this.formData[field.name] = field.value ? field.value : '';
            }
          }


          field.editorOptions = {
            readOnly: field.type.readOnly,
            disabled: field.type.disabled,
            value: this.isEdit ? this.formData[field.name] : this.formData[field.name] || field.value,
            elementAttr: { id: field.name },
            onValueChanged: e => {
              if (field.watch) {
                this.valueChanged(e);
              }
            },
          };


          switch (field.type.name.toLowerCase()) {
            case 'text':
              field.editorOptions.mode = field.type.mode;
              field.editorOptions.mask = field.type.mask;
              field.editorOptions.useMaskedValue = field.type.useMaskedValue;
              field.editorOptions.elementAttr.style = field.direction === 'ltr' ? 'direction:ltr;' : 'direction:inherit;';
              break;
            case 'money':
              field.editorOptions.format = '﷼ #,##0';
              break;
            case 'autocomplete':
              field.editorOptions.dataSource = field.type.options;
              field.editorOptions.placeholder = '';
              field.editorOptions.searchExpr = ['name', 'value', 'search'];
              field.editorOptions.valueExpr = 'value';
              field.editorOptions.displayExpr = 'name';
              field.editorOptions.showClearButton = !(field.rules && field.rules.indexOf('required') !== -1);
              field.editorOptions.minSearchLength = 3;
              field.editorOptions.maxItemCount = 10;
              break;
            case 'select':
              field.editorOptions.dataSource = field.type.options;
              field.editorOptions.displayExpr = 'name';
              field.editorOptions.showClearButton = !(field.rules && field.rules.indexOf('required') !== -1);
              field.editorOptions.valueExpr = 'value';
              field.editorOptions.acceptCustomValue = field.type.edit;
              field.editorOptions.searchEnabled = field.type.searchable;
              break;
            case 'select-simple':
              field.editorOptions.items = field.type.options;
              field.editorOptions.showClearButton = !(field.rules && field.rules.indexOf('required') !== -1);
              field.editorOptions.acceptCustomValue = field.type.edit;
              field.editorOptions.searchEnabled = field.type.searchable;
              break;
            case 'tagbox':
              field.editorOptions.colSpan = field.type.colspan || this.colCount;
              field.editorOptions.dataSource = field.type.options;
              field.editorOptions.displayExpr = 'name';
              field.editorOptions.valueExpr = 'value';
              field.editorOptions.showSelectionControls = !field.type.edit;
              field.editorOptions.acceptCustomValue = field.type.edit;
              field.editorOptions.searchEnabled = true;
              break;
            case 'tagbox-simple':
              field.editorOptions.colSpan = field.type.colspan || this.colCount;
              field.editorOptions.items = field.type.options;
              field.editorOptions.showSelectionControls = !field.type.edit;
              field.editorOptions.acceptCustomValue = field.type.edit;
              field.editorOptions.searchEnabled = true;
              break;
            case 'checkbox':
              field.editorOptions.itemType = 'simple';
              break;
            case 'radio':
              field.editorOptions.dataSource = field.type.options;
              field.editorOptions.displayExpr = 'name';
              field.editorOptions.valueExpr = 'value';
              field.editorOptions.layout = 'horizontal';
              break;
            case 'textarea':
              field.editorOptions.colSpan = field.type.colspan || this.colCount;
              field.editorOptions.height = 90;
              break;
            case 'mobile':
              field.editorOptions.mask = '0000-AAA0000';
              field.editorOptions.elementAttr.style = 'direction: ltr;';
              field.alignment = 'left';
              field.editorOptions.useMaskedValue = field.type.useMaskedValue;
              field.editorOptions.mode = 'tel';
              break;
            case 'tel':
              field.editorOptions.mask = '000-AAAAaaaa';
              field.editorOptions.elementAttr.style = 'direction: ltr;';
              field.alignment = 'left';
              field.editorOptions.useMaskedValue = field.type.useMaskedValue;
              field.editorOptions.mode = 'tel';
              break;
            case 'uploader':
              field.editorOptions = {
                labelText: '',
                uploadUrl: this.uploadUrl,
                uploadMode: 'useButtons',
                accept: 'image/*,audio/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.zip',
                uploadHeaders: {
                  token: this.token,
                  path: this.uploadPath,
                  caption: field.name.toLowerCase()
                },
                onUploaded: e => {
                  if (this.uploadPath) {
                    this.onUploaded(e);
                  }
                }
              };
              break;
            case 'list':
              if (!this.formData[field.name]) {
                this.formData[field.name] = [];
              } else {
                try {
                  this.formData[field.name] = JSON.parse(this.formData[field.name])
                } catch (error) {
                }
              }
              this.lists.push(field);
              break;
            default:
              break;
          }

        }
        resolve(field);
      } catch (error) {
        reject(error);
      }
    });

  }

  async custom(field) {
    return field;
  }

  private async loadFieldOptions(field: any) {
    if (field.type.option.query) {
      field.type.option.query = JSON.parse(JSON.stringify(field.type.option.query)
        .replace(/#self/g, this.selectedAccount || this.username));
    }
    const result = (await this.service.apiCall(field.type.option.api,
      {
        fields: [field.type.option.value, field.type.option.name || field.type.option.value],
        query: field.type.option.query,
        orderby: field.type.option.orderby,
        desc: field.type.option.desc,
        ttl: 600,
        raw: true
      }).toPromise());
    if (field.type.option.name) {
      field.type.options = result.map(r => ({ value: r[field.type.option.value], name: r[field.type.option.name] }));
      // if (field.type.name.toLowerCase() === 'autocomplete') {
      //   this.changeDataSource(field.name, field.type.options);
      //   setTimeout(() => {
      //     this.changeValue(field.name, this.formData[field.name] || field.value);
      //   }, 5000);
      // }
    } else {
      field.type.options = result.map(r => r[field.type.option.value]);
      // if (field.type.name.toLowerCase() === 'autocomplete') {
      //   console.log(this.formData[field.name]);
      //   this.changeDataSource(field.name, field.type.options);
      //   setTimeout(() => {
      //     this.changeValue(field.name, this.formData[field.name] || field.value);
      //   }, 5000);
      // }
    }
  }

  changeItemOptions(field, option, value) {
    const formField = this.form.instance.itemOption(field);
    if (formField) {
      formField.editorOptions[option] = value;
      this.form.instance.itemOption(field, 'editorOptions', formField.editorOptions);
    } else {
      console.error(`Form field not found ${field}`);
    }

  }

  changeDataSource(field, value) {
    this.changeItemOptions(field, 'dataSource', value);
  }

  changeReadonly(field, value) {
    this.changeItemOptions(field, 'readOnly', value);
  }

  changeDisabled(field, value) {
    this.changeItemOptions(field, 'disabled', value);
  }

  changeVisible(field, value) {
    this.changeItemOptions(field, 'visible', value);
  }

  changeValue(field, value) {
    this.changeItemOptions(field, 'value', value);
  }

  async manipulate(data) {
    for (const date of this.fields.filter(f => f.type && f.type.name === 'date')) {
      if (data[date.name] && data[date.name] < '1500') {
        data[date.name] = moment(data[date.name], 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
      } else {
        data[date.name] = data[date.name] ? moment(data[date.name]).format('YYYY-MM-DD') : null;
      }
    }

    for (const datetime of this.fields.filter(f => f.type && f.type.name === 'datetime')) {
      if (data[datetime.name] && data[datetime.name] < '1500') {
        data[datetime.name] = moment(data[datetime.name], 'jYYYY-jMM-jDD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
      } else {
        data[datetime.name] = data[datetime.name] ? moment(data[datetime.name]).format('YYYY-MM-DD HH:mm:ss') : null;
      }
    }

    if (this.isEdit) {
      for (const tagbox of this.fields.filter(f => f.type && f.type.name.includes('tagbox'))) {
        if (data[tagbox.name]) {
          data[tagbox.name] = data[tagbox.name].split(',');
        }
      }
    }
  }

  getApi(): string {
    return `api/${this.entityName.toLowerCase()}/${this.id || this.forceUpdate ? 'update' : 'create'}`;
  }

  getBody(): any {
    return this.body;
  }

  // validateItem() {
  //   // this.validateLog = [];
  //   this.customValidation(this.formData);
  //   this.fields.forEach(field => {
  //     field.alerts = [];

  //     if (field.type.confirm) {
  //       if (this.formData[field.name] !== this.formData[field.name + '-confirm']) {
  //         field.alerts.push('CONFIRM_DOES_NOT_MATCH');
  //         this.invalid = true;
  //       }
  //     }
  //     if (field.rules) {

  //       field.rules.forEach(validator => {
  //         try {
  //           if (this.formData[field.name] === undefined) {
  //             this.formData[field.name] = field.value;
  //           }
  //           const message = validator.validate(this.formData[field.name]).message;
  //           if (message) {
  //             this.invalid = true;
  //             field.alerts.push(message);
  //           }
  //         } catch (error) {
  //           console.error(field, validator, error);
  //         }
  //       });
  //     }
  //   });
  //   return !this.invalid;
  // }

  save(body, apply) {
    if (!this.supressSave && this.entityName) {
      this.service.apiCall(this.getApi(), body).subscribe((result: any) => {
        this.afterSave(body);
        this.loading = false;
        if (!apply) {
          this.activeModal.close({ result: result, body: body });
          this.handleSuccess();
        } else {
          this.handleWarning(this.translator.instant('GENERAL_ERROR'));
        }
      }, error => {
        this.loading = false;
        this.handleError(error);
      });
    } else {
      this.done.emit(body);
    }
  }

  afterSave(body) {
    this.done.emit(body);
  }

  // onCustomItemCreating = (args) => {
  //   const newValue = {
  //     name: args.text, value: args.text
  //   };
  //   const newopt3 = this.form.instance.getEditor(args.element.id);
  //   return newValue;
  // }

  clear() {
    this.fields.filter(f => !f.type.disabled && !f.type.readOnly).forEach(element => {
      this.formData[element.name] = null;
    });
    this.lists = [];
  }

  onUploaded = (e) => {
    this.uploadingList.push({ filename: e.request.responseText, path: this.uploadPath });
  }

  async customValidation(data) {
    let isValid = true;
    const requiredDateTimeFields = this.fields.filter(f => f.type &&
      ['date', 'time', 'datetime'].includes(f.type.name) &&
      f.rules &&
      f.rules.find(r => r.type === 'required'));
    for (const field of requiredDateTimeFields) {
      isValid = isValid && data[field.name];
    }
    return isValid;
  }

  changeDateFormat(e) {
  }

  cancel(e) {
    this.activeModal.close();
  }

  revertDate(body) {
    this.fields.forEach(item => {
      if (item.type.name === 'datetime') {
        const date = this.formData[item.name];
        if (date) {
          this.formData[item.name] = (typeof (date) === 'string' ?
            moment(date, 'YYYY-MM-DD HH:mm:ss') : date).locale('fa').format('jYYYY-jMM-jDD HH:mm:ss');
        } else {
          this.formData[item.name] = null;
        }
      } else if (item.type.name === 'date') {
        const date = this.formData[item.name];
        if (date) {
          this.formData[item.name] = (typeof (date) === 'string' ?
            moment(date, 'YYYY-MM-DD') : date).locale('fa').format('jYYYY-jMM-jDD');
        } else {
          this.formData[item.name] = null;
        }
      }
    });
  }

  async submit(event) {
    if (this.form.instance.validate().isValid && await this.customValidation(this.formData)) {
      this.loading = true;
      const body = this.getBody();
      if (this.uploadingList && this.uploadingList.length) {
        body['uploadingList'] = this.uploadingList;
        body['path'] = this.uploadPath;
      }

      this.fields.forEach(item => {
        body[item.name] = this.formData[item.name] === '' ? null : this.formData[item.name];
        if (item.type.name === 'datetime' || item.type.name === 'date') {
          if (!this.formData[item.name]) {
            body[item.name] = null;
          }
        }
        // if (item.type.name === 'datetime') {
        //   const date = this.formData[item.name];
        //   if (date) {
        //     body[item.name] = (typeof (date) === 'string' ?
        //       moment(date, 'jYYYY-jMM-jDD HH:mm:ss') : date).locale('en').format('YYYY-MM-DD HH:mm:ss');
        //   } else {
        //     body[item.name] = null;
        //   }
        // } else if (item.type.name === 'date') {
        //   const date = this.formData[item.name];
        //   if (date) {
        //     body[item.name] = (typeof (date) === 'string' ?
        //       moment(date, 'jYYYY-jMM-jDD') : date).locale('en').format('YYYY-MM-DD');
        //   } else {
        //     body[item.name] = null;
        //   }
        // } else if ((item.type.name === 'tagbox' || item.type.name === 'tagboxlist')
        //   && this.formData[item.name]
        //   && this.formData[item.name].length) {
        //   body[item.name] = this.formData[item.name].join();
        // } else {
        // body[item.name] = this.formData[item.name] === '' ? null : this.formData[item.name];
        // }
        // if (this.formData.password) { body['password'] = this.formData.password; }
      });

      this.save(body, event.element === 'save');
    }
  }

  async valueChanged(e) {
  }

  onDateChange(column, value) {
  }

  onListSaving(field, event) {
    for (const c of event.changes) {
      for (const k of Object.keys(c.data)) {
        if (typeof c.data[k] == 'string') {
          c.data[k] = c.data[k].trim();
        }
      }
    }
  }

}
